import React from 'react'
import { ListStudents } from 'features/students'

export default function ListWithoutAccessPage() {
  return <ListStudents />
}
